
import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import InputGroup from 'react-bootstrap/InputGroup';
import FormControl from 'react-bootstrap/FormControl';
import Button from 'react-bootstrap/Button';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';

import { PAGE_NAME } from '../globals';

export interface FiltersProps {
  isGridOnlyView: boolean,
  selectedLetter: string,
  clickViewAllHandler: (arg0: React.SyntheticEvent) => void,
  updateSelectedLetter: (arg0: string) => void,
}

const Filters: React.FunctionComponent<FiltersProps> = ({
  isGridOnlyView,
  selectedLetter,
  clickViewAllHandler,
  updateSelectedLetter,
}) => (
  <>
    <Row className="filter-control filter-control--search">
      <Col
        xs={{ span: 12 }}
        md={{ span: 6, offset: isGridOnlyView ? 3 : 4 }}
        className="mb-2"
      >
        <InputGroup className="mt-4">
          <FormControl
            placeholder="search article title"
          />
          <InputGroup.Append>
            <Button variant="outline-secondary">
              <FontAwesomeIcon icon={faSearch} />
            </Button>
          </InputGroup.Append>
        </InputGroup>
      </Col>
    </Row>
    <Row className="filter-control filter-control--slider">
      <Col
        xs={{ span: 12 }}
        md={{ span: 8, offset: isGridOnlyView ? 2 : 3 }}
      >
        <div className="letter-filters">
          {
            'abcdefghijklmnopqrstuvwxyz'
              .split('')
              .map((letter, i) => (
                <a
                  key={i}
                  href={`/--${PAGE_NAME}#filterletter=${letter}`}
                  onClick={()=>updateSelectedLetter(letter)}
                  title={`Filter articles starting with "${letter.toUpperCase()}"`}
                  className={`btn btn-link letter-filters__filter ${selectedLetter === letter ? 'active' : ''}`}>
                  {letter}
                </a>
              ))
          }
        </div>
      </Col>
      <Col
        className="mb-4 text-center"
        xs={{ span: 12 }}
        md={{ span: 8, offset: isGridOnlyView ? 2 : 3 }}
      >
        <a
          href={`/--${PAGE_NAME}#`}
          className="btn btn-link btn--all-featured"
          onClick={clickViewAllHandler}
        >
          view all featured
        </a>
      </Col>
    </Row>
  </>
);

export default Filters;